import { lazy } from 'react';

export default function lazyWithReload(componentImport: () => Promise<any>) {
  return lazy(async () => {
    try {
      return await componentImport();
    } catch (error: any) {
      // Check if it's a dynamic import failure (chunk load error)
      if (
        error.message.includes('Failed to fetch dynamically imported module') ||
        error.message.includes('Importing a module script failed') ||
        error.message.includes('Loading chunk') ||
        error.message.includes('dynamically imported module')
      ) {
        // If a new deployment invalidated the chunk, force a hard reload
        // to get the new index.html with the correct chunk hashes
        window.location.reload();
      }
      throw error;
    }
  });
}
